var React = require('react');

function GameBoard (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M480 0H32A32 32 0 0 0 0 32v448a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zm-31.8 448H64v-96h.2v-96H64v-96h.2V64h384z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 256v-96h-95.9V64.1h-96v96H160V256H64.2v96h96v-96zm0 96h-95.8v96h96v-96H352v-96h-96zm96.1 96.1h96v-96h-96zm.1-288.1v96h96v-96zm-96-96v96h96V64z","className":"fa-primary","key":2})]);
}

GameBoard.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = GameBoard;

GameBoard.default = GameBoard;
